module.exports = __webpack_public_path__ + "media/android欢迎语.fff085a2.mp3";